import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { isScreenBelow640 } from 'store/common/settings/breakpoint/selectors';
import { TabEnum } from 'store/ProductDetails/constants';
import { getActiveContentTabSlug, getContentTabsHash } from 'store/ProductDetails/selectors';

import {
  CharacteristicsTab,
  CrossSellTab,
  CustomContentTab,
  DeliveryTab,
  FeedbackTab,
  PaymentTab,
  PreorderTab,
  ServicesTab,
} from '../index';

const tabsHash = {
  [TabEnum.CONTENT_TAB_ABOUT]: CharacteristicsTab,
  [TabEnum.CONTENT_TAB_CROSS_SALE]: CrossSellTab,
  [TabEnum.CONTENT_TAB_DELIVERY]: DeliveryTab,
  [TabEnum.CONTENT_TAB_FEEDBACK]: FeedbackTab,
  [TabEnum.CONTENT_TAB_PAYMENT]: PaymentTab,
  [TabEnum.CONTENT_TAB_PREORDER]: PreorderTab,
  [TabEnum.CONTENT_TAB_SERVICES]: ServicesTab,
};

export const TabRouter = () => {
  const { activeSlug, isMobile, tabListHash } = useSelector(
    (state) => ({
      activeSlug: getActiveContentTabSlug(state),
      isMobile: isScreenBelow640(state),
      tabListHash: getContentTabsHash(state),
    }),
    shallowEqual,
  );

  const CurrentTab = tabsHash[activeSlug];
  const { html, htmlAdaptive } = tabListHash[activeSlug];

  const Tab = CurrentTab || CustomContentTab;
  return <Tab {...{ content: (isMobile && htmlAdaptive) || html }} activeSlug={activeSlug} />;
};

export default TabRouter;
